import { Component, OnInit, Input, HostBinding, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { InvoiceService } from '../../../../core/services/invoice.service';
import { User } from '../../../../models/user';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UsuarioDIEZdesplegable } from 'src/app/models/usuariosDIEZdesplegable';
import * as enumTiposFactura from '../../../../shared/enums/tiposFacturas.enum';
import { DocPendientesDigitalizar } from 'src/app/models/docPendientesDigitalizar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listadoDocs',
  templateUrl: './listadoDocs.component.html',
  styleUrls: ['./listadoDocs.component.css']
})
export class InvoicerListadoDocsComponent implements OnInit {

  storageKey = 'sdmInvoicerCurrentUser';
  usuarioSDM = JSON.parse(localStorage.getItem(this.storageKey));

  @HostBinding('class.is-open')
  isOpen = false;
  toggle() {
    this.isOpen = !this.isOpen;
  }
  @Input() usuarioActual: User;
  @Output() documentEventPASAR: EventEmitter<any> = new EventEmitter();

  //variables
  currentUser: User;
  filtro: FormGroup;
  HoyMoment = moment();
  tiposDeFacturasRecibidas: enumTiposFactura.iTipoFactura[];
  tiposDeFacturasEmitidas: enumTiposFactura.iTipoFactura[];

  estadosFiltradoDigitalizarPARAsupervisor = [
    {
      id: 1,
      value: 'Pendientes'
    },
    {
      id: 2,
      value: 'Procesados (Todos)'
    },
    {
      id: 3,
      value: 'Procesados (Propio)'
    },
    {
      id: 20,
      value: 'Supervisar'
    },
    {
      id: 4,
      value: 'Contabilizados'
    }
  ];
  estadosFiltradoDigitalizar = [{
    id: 1,
    value: 'Pendientes'
  }];
  tiposDocFiltradoDigitalizar = [{
    id: 1,
    value: 'Emitidos'
  }, {
    id: 2,
    value: 'Recibidos'
  }, {
    id: 3,
    value: 'Todos'
  }]

  listaUsuariosDIEZ: UsuarioDIEZdesplegable[] = [];


  estaCargandoListado = false;
  cargaListado = false;
  listadoDigitalizar: DocPendientesDigitalizar[] = [];
  valorPrinSec = ''; //por defecto
  valorIDdoc = 0;
  valorEstado = 0; //por defecto (utiliza index mas adelante, por eso es 0)
  valorTieneIncidencia = false;
  valorTipoDoc = 3; //por defecto
  valorNUMFACT = ''; //por defecto
  totalDocumentosTraidos = 0; //por defecto
  textoTipoFacturas: string;

  constructor(
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    this.currentUser = this.authService.currentUserValue;
    this.tiposDeFacturasEmitidas = enumTiposFactura.TiposDeFacturasEmitidas;
    this.tiposDeFacturasRecibidas = enumTiposFactura.TiposDeFacturasRecibidas;

    this.invoiceService.obtenerUsuariosDIEZinvoicer().subscribe(resultado => {
      //console.log(resultado);
      this.listaUsuariosDIEZ = resultado;

      var usuarioDefecto: UsuarioDIEZdesplegable = {
        id: 0,
        nombreEmail: "Sin especificar"
      };
      this.listaUsuariosDIEZ.push(usuarioDefecto);

      this.listaUsuariosDIEZ = this.listaUsuariosDIEZ
        .sort(function (a, b) {
          if (b.id > a.id) { return -1; }
          if (b.id < a.id) { return 1; }
          return 0;
        });

      console.log(this.listaUsuariosDIEZ);

    }, error => {
      this.toastr.error('Error en la obtención de usuarios DIEZ del invoicer');
      console.log(error);
    });

    this.filtro = this.fb.group({
      idDocumento: [''],
      desdeFecha: [''],
      hastaFecha: [''],
      tipoDocumento: [0],
      estadoDocumento: [0],
      estadoDocumentoSUPER: [0],
      usuarioDIEZ: [0],
      principalSecundario: [''],
      numFactura: [''],
      impTotal: [0],
      fechaFactura: [''],
      nombreEmp: [''],
      tieneIncidencia: [false]
    });

    if (this.currentUser.facturasCliente != null && this.currentUser.facturasCliente != "" && this.currentUser.facturasCliente != " ") {

      var value = this.currentUser.facturasCliente;
      this.valorPrinSec = value;

      this.filtro.patchValue({
        principalSecundario: value
      });
      this.filtro.get("principalSecundario").disable();
      this.filtro.get("idDocumento").disable();
    }

    moment.locale('es');
    this.HoyMoment = moment();

    this.filtro.patchValue({ desdeFecha: this.HoyMoment.format('DD/MM/YYYY') });
  }

  ngOnInit() {
    this.listadoDigitalizar = [];
    this.estaCargandoListado = false;
    this.cargaListado = false;
    this.textoTipoFacturas = "";
  }

  irDocumentoClick(idFactura) {

    //propiedades de componente PRINCIPAL
    console.log("CARGANDO DATOS DE FACTURA CON ID --> " + idFactura);

    if (idFactura != undefined || idFactura != null) {
      console.warn("Emitiendo factura...", idFactura);
      this.documentEventPASAR.emit(idFactura);
    };
  }

  cambiarEstadoListado($event) {

    let valor = $event.target.options.selectedIndex;
    this.valorEstado = valor;
  }

  cambiarTipoDOCListado($event) {

    let valor = $event.target.options.selectedIndex;

    if (valor == 0) {
      this.valorTipoDoc = 1;
    }

    if (valor == 1) {
      this.valorTipoDoc = 2;
    }

    if (valor == 2) {
      this.valorTipoDoc = 3;
    }
  }

  principalSecundarioSearch($event) {

    let valorCOD: string = $event.target.value;
    this.valorPrinSec = valorCOD;

  }

  idDocSearch($event) {
    let value = $event.target.value;
    this.valorIDdoc = value;
  }

  numFacturaSearch($event) {

    let valorNUMFACT: string = $event.target.value;
    this.valorNUMFACT = valorNUMFACT;
  }

  buscarConFiltros() {

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {

        this.listadoDigitalizar = [];
        this.estaCargandoListado = true;
        this.cargaListado = true;
        this.totalDocumentosTraidos = 0;

        switch (this.valorEstado) {
          case 0: this.textoTipoFacturas = "pendientes de digitalizar";
            break;
          case 1: this.textoTipoFacturas = "procesadas (Todos)";
            break;
          case 2: this.textoTipoFacturas = "procesadas (Propios)";
            break;
          case 3: this.textoTipoFacturas = "pendientes de revisar";
            break;
          case 4: this.textoTipoFacturas = "contabilizadas";
            break;
        }
        this.valorTieneIncidencia = this.filtro.get("tieneIncidencia").value;
        var valorFecha = (this.filtro.get('desdeFecha').value != '') ? this.filtro.get('desdeFecha').value : 0;
        var valorFechaHasta = (this.filtro.get('hastaFecha').value != '') ? this.filtro.get('hastaFecha').value : 0;
        var valorFechaFACTURA = (this.filtro.get('fechaFactura').value != '') ? this.filtro.get('fechaFactura').value : 0;
        var valorUsuarioDIEZ = (this.filtro.get('usuarioDIEZ').value != 0) ? this.filtro.get('usuarioDIEZ').value : 5000;
        var valorEmpresaNombre = (this.filtro.get('nombreEmp').value != '') ? this.filtro.get('nombreEmp').value : "vacio";
        var valorImporteFACTURA = (this.filtro.get('impTotal').value != 0) ? this.filtro.get('impTotal').value : 0;

        this.invoiceService.cargarListadoDocumentos(

          this.valorIDdoc,
          this.usuarioActual.email,
          this.valorPrinSec.trim(),
          this.valorNUMFACT.trim(),
          this.valorTipoDoc,
          this.valorEstado,
          (valorFecha != 0) ? this.GetFechaInteger(valorFecha) : 0,
          (valorFechaHasta != 0) ? this.GetFechaInteger(valorFechaHasta) : 0,
          valorUsuarioDIEZ,
          (valorFechaFACTURA != 0) ? this.GetFechaInteger(valorFechaFACTURA) : 0,
          valorEmpresaNombre,
          valorImporteFACTURA,
          this.valorTieneIncidencia

        ).subscribe(documentosLeidos => {
          this.listadoDigitalizar = documentosLeidos;

          this.totalDocumentosTraidos = this.listadoDigitalizar.length;

          if (this.valorEstado == 0 || this.valorEstado == 3) { //Pendientes y Revisar
            this.listadoDigitalizar.sort((n1, n2) => {
              if (n1.fecha > n2.fecha) {
                return 1;
              } else if (n1.fecha < n2.fecha) {
                return -1;
              } else if (n1.hora > n2.hora) {
                return 1;
              } else if (n1.hora < n2.hora) {
                return -1;
              }

              return 0;
            });
          } else if (this.valorEstado == 1 || this.valorEstado == 2 || this.valorEstado == 4) { //Procesados y contabilizados
            this.listadoDigitalizar.sort((n1, n2) => {
              if (n1.fechaRevisionFinal > n2.fechaRevisionFinal) {
                return -1;
              } else if (n1.fechaRevisionFinal < n2.fechaRevisionFinal) {
                return 1;
              } else if (n1.horaRevisionFinal > n2.horaRevisionFinal) {
                return -1;
              } else if (n1.horaRevisionFinal < n2.horaRevisionFinal) {
                return 1;
              }

              return 0;
            });
          }

          var filtro = [];

          //Agrupación de datos para luego hacer lectura y texto tipoFactura
          for (var i = 0; i < this.listadoDigitalizar.length; i++) {
            if (filtro.filter(filas => filas.secundario == this.listadoDigitalizar[i].secundario).length == 0) {
              filtro.push({ usuario: this.listadoDigitalizar[i].usuario, secundario: this.listadoDigitalizar[i].secundario });
            }

            var result = undefined;

            //texto tipo factura:
            if (this.listadoDigitalizar[i].tipoDocumento == 1) { //emitidas

              result = this.tiposDeFacturasEmitidas.find(d => d.id == this.listadoDigitalizar[i].tipoFactura);

              if (result != undefined) {
                this.listadoDigitalizar[i].tipoFacturaTEXT = result.value;
              }

            } else { //recibidas

              result = this.tiposDeFacturasRecibidas.find(d => d.id == this.listadoDigitalizar[i].tipoFactura);

              if (result != undefined) {
                this.listadoDigitalizar[i].tipoFacturaTEXT = result.value;
              }
            }
          }

          this.invoiceService.cargarNombresSecundariosPrincipales(filtro).subscribe(doc => {

            for (var i = 0; i < this.listadoDigitalizar.length; i++) {

              for (var f = 0; f < doc.length; f++) {

                if (this.listadoDigitalizar[i].secundario == doc[f].secundario) {

                  var nameSec = doc[f].nombreSecundario;
                  var namePrin = doc[f].nombrePrincipal;

                  this.listadoDigitalizar[i].nombreSec = nameSec;
                  this.listadoDigitalizar[i].nombrePrin = namePrin;
                }

              }
            }

            this.cargaListado = false;
            this.estaCargandoListado = false;
          });
        }, error => {
          console.log(error);
          this.toastr.error("Error al intentar cargar los datos del listado");
          this.cargaListado = false;
          this.estaCargandoListado = false;
        });
      }

    }, error => {
      console.log(error);
    });
  }

  fechaChange(queFecha: number, $event) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    // alert(resultado);

    if (queFecha == 1) {

      this.filtro.patchValue({
        desdeFecha: resultado
      });

    } else if (queFecha == 2) {

      this.filtro.patchValue({
        hastaFecha: resultado
      });

    } else {

      this.filtro.patchValue({
        fechaFactura: resultado
      });
    }
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  public GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  convertThousandsFixed(number: any, digits) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');
    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();
    var output = '';
    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + ',' + numbers[1];
      }
    }

    if (digits === '0') {
      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }

}
